import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, ArrowRight } from 'lucide-react';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-slate-950 flex flex-col items-center justify-center relative overflow-hidden" data-id="element-375">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-376">
        <img src="https://cdn.magicpatterns.com/uploads/xs3FNRVmAJVyjcqUEfuovH/Renewables-Application.jpg" alt="Renewable energy infrastructure" className="w-full h-full object-cover opacity-15" data-id="element-377" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950/90 via-slate-950/95 to-slate-950" data-id="element-378"></div>
      </div>

      {/* Background Effects */}
      <div className="absolute inset-0 z-0" data-id="element-379">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-emerald-500/20 rounded-full blur-[120px] opacity-50 animate-pulse" data-id="element-380"></div>
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-emerald-900/20 via-slate-950 to-slate-950" data-id="element-381"></div>
      </div>

      <div className="z-10 flex flex-col items-center text-center px-4 max-w-4xl mx-auto" data-id="element-382">
        <div className="inline-flex items-center justify-center p-3 bg-emerald-500/10 rounded-2xl mb-8 border border-emerald-500/20 backdrop-blur-sm" data-id="element-383">
          <Zap className="w-8 h-8 text-emerald-400" data-id="element-384" />
        </div>

        <h1 className="text-5xl md:text-7xl font-extrabold text-white tracking-tight mb-6 leading-tight" data-id="element-385">
          Enter the Era of <br data-id="element-386" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-cyan-400" data-id="element-387">
            Intelligent Energy
          </span>
        </h1>

        <p className="text-xl md:text-2xl text-slate-400 mb-12 max-w-2xl font-light" data-id="element-388">
          Green Fuel converts methane waste into electricity and hydrogen using
          AI-powered bio-digesters.
        </p>

        <Link to="/home" className="group relative inline-flex items-center justify-center px-8 py-4 font-bold text-white transition-all duration-200 bg-emerald-600 font-pj rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-600 hover:bg-emerald-500 hover:shadow-[0_0_40px_rgba(16,185,129,0.4)]" aria-label="Enter main site" data-id="element-389">
          Explore the Future
          <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-390" />
        </Link>
      </div>
    </main>;
}